import BatchUploadManager from "./BatchUploadManager";
import FileUploadManager from "./FileUploadManager";
import axios from "axios";
class FileUploadManagerInjected extends FileUploadManager {
    constructor(file, options) {
        super(axios, file, options);
    }
}
class BatchUploadManagerInjected extends BatchUploadManager {
    constructor(options) {
        super(axios, options);
    }
}
export { FileUploadManagerInjected as FileUploadManager, BatchUploadManagerInjected as BatchUploadManager, };
//# sourceMappingURL=index.js.map